import { findDomForWindow } from '../utils';
var handleFrameResize = function handleFrameResize(event, postMessageService) {
  var ltiIframe = findDomForWindow(event.source);
  if (ltiIframe && event.data.height > 0) {
    ltiIframe.height = event.data.height + 'px';
    ltiIframe.style.height = event.data.height + 'px';
    postMessageService.sendSuccessPostMessageResponse('lti.frameResize', undefined, event.source, event.origin);
  }
};
export default handleFrameResize;